module.exports = __webpack_public_path__ + "static/media/S3N10-6.53ff1577.svg";